module.exports = __webpack_public_path__ + "img/millarium_tech_Normal_ua.4933f9e0.webp";